import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { DistributionGroup } from 'src/app/models/distribution-group.model';
import { DistributionGroupStore } from '../../store/distribution-group-store';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatDialog } from '@angular/material/dialog';
import { ToggleComponent } from 'src/app/shared/components/toggle/toggle.component';

@Component({
    selector: 'que-distribution-group-menu-item',
    imports: [CommonModule, MatMenuModule, TranslateDirective, TranslatePipe, OverlayModule, ToggleComponent],
    templateUrl: './distribution-group-menu-item.component.html',
    styleUrls: ['./distribution-group-menu-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DistributionGroupMenuItemComponent implements OnInit {
  @Input()
  distributionGroup?: DistributionGroup;
  @Output()
  editEvent = new EventEmitter;
  @ViewChild('trigger') trigger!: ElementRef;
  #distributionGroupStore = inject(DistributionGroupStore);
  #dialog = inject(MatDialog);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  isDisplayNotActiveItems$ = toSignal(this.#manipulationsToolbarStore.isDisplayNotActiveItems$);
  isMenuOpen = false;
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  ngOnInit(): void {

  }

  openMenu($event: Event) {
    $event.stopPropagation();
    const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // Check if the menu would open out of the viewport
    if (triggerRect.bottom + 200 > viewportHeight) { // assuming 200px height for the menu
      this.positonArea[0].overlayY = 'bottom';
    } else {
      this.positonArea[0].overlayY = 'top';
    }
    this.isMenuOpen = true
  }

  edit() {
    this.isMenuOpen=false;
    this.editEvent.emit();
  }

  changeStatus() {
    this.isMenuOpen = false;
    this.#distributionGroupStore.changeStatusDistributionGroup(this.distributionGroup!.id)
  }
}
